import { chakra } from '@chakra-ui/react';

export const Label = chakra('label', {
  base: {
    display: 'block',
  },
});
